<template>
    <v-dialog
            v-model="open"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            scrollable
    >
        <v-card tile>
            <v-toolbar card dark color="primary">
                <v-btn :disabled="status === 'submitted'" icon dark @click="closeForm()">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ project.displayName }}</v-toolbar-title>
            </v-toolbar>
            <in-progress-project-dialog
                    :project="project"
                    v-on:submitted="build"
                    :status="status"
                    ref="form"
                    v-if="status === 'inProgress'">
            </in-progress-project-dialog>
            <submitted-project-dialog
                    :project="project"
                    :status="status"
                    v-if="status === 'submitted' || status === 'resume'">
            </submitted-project-dialog>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapGetters } from "vuex";
    import InProgressProjectDialog from './InProgressProjectDialog';
    import SubmittedProjectDialog from './SubmittedProjectDialog';

    export default {
        name: "FirebaseProjectForm",
        components: {
            InProgressProjectDialog,
            SubmittedProjectDialog
        },
        props: {
            open: {
                type: Boolean,
            },
            project: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                status: 'inProgress',
                close: false,
            }
        },
        computed: {
            ...mapGetters({
                firebaseProject: "projects/firebaseProject",
                androidApp: "projects/androidApp",
                iosApp: "projects/iosApp",
                sha: "projects/sha",
            }),
        },
        methods: {
            closeForm() {
                this.status = 'inProgress';
                this.$store.dispatch('projects/resetBuildResult');
                if (this.$refs.form) {
                    this.$refs.form.clear();
                }
                this.$emit('close');
            },
            async build(form) {
                // this.$refs.form.clear();
                this.status = 'submitted';
                await this.$store.dispatch('projects/createFirebaseProject', { project: this.project, form });
                await this.$store.dispatch('projects/addAndroidApp', { firebaseProject: this.firebaseProject, form });
                await this.$store.dispatch('projects/addIosApp', { firebaseProject: this.firebaseProject, form });
                await this.$store.dispatch('projects/addSha', { androidApp: this.androidApp, form });
                this.status = 'resume';
            }
        }
    }
</script>

<style scoped>

</style>
